import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import AccessDenied from "@/pages/AccessDenied";

export default function RequireCatalogue({ children }) {
  const [ok, setOk] = useState(null);
  useEffect(() => { api.get("/gshop-readiness/access").then((r) => setOk(!!r.data.catalogue)).catch(() => setOk(false)); }, []);
  if (ok === null) return <div className="p-6 text-sm text-slate-400" data-testid="catalogue-access-checking">Checking access…</div>;
  if (!ok) return <AccessDenied message="Catalogue and Google Shopping screens need a company owner/admin role or the “catalogue.publish” permission." />;
  return children;
}
